<template>
  <WsMain
    :style="[{'padding-bottom':'220px'}]"
  >
    <WsBreadCrumbs :items="_breadcrumbsItems"></WsBreadCrumbs>
    <div class="ws-button-group">
      <WsBtn
        color="textSecondary"
        outlined
        @click="$_onEditOpen()"
      >
        <v-icon left>mdi-pencil</v-icon> 編輯
      </WsBtn>
    </div>
    <div class="ws-read-content-block">
      <WsCard>
        <WsContent>
          <WsContentTitle>APP版本管理</WsContentTitle>
          <WsInfo
            v-for="(item, key, index) in fields"
            :key="index"
            :label="$_CMS_getLabelByHideLabelFields(key,fields)"
            :type="$_CMS_getFieldByFieldKey(key,fields).type"
            :maxWidth="$_CMS_getFieldByFieldKey(key,fields).maxWidth"
            :originData="modelData"
            :value="$_CMS_getValueByFieldKey(key,modelData)"
          ></WsInfo>
        </WsContent>
      </WsCard>
    </div>
    <WsUpdateDialog
      ref="appVersionDialog"
      :label="label"
      :fields="_appFields"
      :modelName="modelName"
      @update-submit="$_onUpdateSubmit($event)"
    />
  </WsMain>
</template>

<script>
import model from "@/models/app_version_management";
export default {
  data: () => ({
    modelData: {
      minimum_Android_APP_version_available: null,
      minimum_Android_OS_version_required: null,
      minimum_iOS_APP_version_available: null,
      minimum_iOS_OS_version_required: null,
      updated_admin: null,
      updated_at: null,
    },
    modelName: model.modelName,
    label: model.label,
    fields: {
      minimum_Android_APP_version_available: {
        type: 'text',
        label: 'Android最低可使用應用程式版本',
        rules: 'required',
        maxlength: 30,
        getUrl: '/other_data/key/minimum_Android_APP_version_available'
      },
      minimum_Android_OS_version_required: {
        type: 'text',
        label: 'Android最低支援作業系統版本',
        rules: 'required',
        maxlength: 30,
        getUrl: '/other_data/key/minimum_Android_OS_version_required'
      },
      minimum_iOS_APP_version_available: {
        type: 'text',
        label: 'iOS最低可使用應用程式版本',
        rules: 'required',
        maxlength: 30,
        getUrl: '/other_data/key/minimum_iOS_APP_version_available'
      },
      minimum_iOS_OS_version_required: {
        type: 'text',
        label: 'iOS最低支援作業系統版本',
        rules: 'required',
        maxlength: 30,
        getUrl: '/other_data/key/minimum_iOS_OS_version_required'
      },
      updated_at: {
        type: 'datetime',
        label: '最後編輯時間',
        readonly: true,
      },
      updated_admin: {
        type: 'belongsTo',
        label: '最後編輯人',
        readonly: true,
        textKey: 'name',
        modeldataName: 'admin',
      },
    },
  }),
  computed:{
    _breadcrumbsItems() {
      const _breadcrumbsItems = [];
      _breadcrumbsItems.push({
        text: this.label,
        to: `/${this.modelName}`,
        disabled: true,
      });
      return _breadcrumbsItems;
    },
    _appFields() {
      return this.$_CMS_geUpdateFields(this.fields);
    },
  },
  methods:{
    $_onEditOpen() {
      this.$refs.appVersionDialog.open(this.modelData)
    },
    async $_onUpdateSubmit($event) {
      let task = []
      for (let key in this.fields) {
        if (this.fields[key].getUrl) {
          const payload = {
            key,
            payload: {version: $event[key]}
          }
          task.push(this.$axios.patch(this.fields[key].getUrl, payload))
        }
      }
      try {
        await Promise.all(task)
        this.$refs.appVersionDialog.close()
        this.$_fetchData()
      } catch (error) {
        alert(error)
      }
    },
    async $_fetchData() {
      this.$store.dispatch("app/startPageLoading");
      this.$store.dispatch("locale/changeLanguageAble");
      let task = []
      for (let key in this.fields) {
        const field = this.fields[key]
        if (field.getUrl) {
          task.push(this.$axios.get(field.getUrl))
        }
      }
      try {
        const res = await Promise.all(task)
        for (let item of res){
          this.modelData = {
            ...this.modelData, 
            [item.data.data.key]: item.data.data.payload.version, 
            updated_at: !this.modelData.updated_at
            ? this.$moment(item.data.data.updated_at).format("YYYY-MM-DD HH:mm:ss")
            : this.$moment(this.modelData.update_at).isAfter(this.$moment(item.data.data.updated_at))
            ? this.$moment(this.modelData.update_at).format("YYYY-MM-DD HH:mm:ss") 
            : this.$moment(item.data.data.updated_at).format("YYYY-MM-DD HH:mm:ss"),
            updated_admin: !this.modelData.updated_admin 
            ? item.data.data.updated_admin
            : this.$moment(this.modelData.update_at).isAfter(this.$moment(item.data.data.updated_at))
            ? this.modelData.updated_admin
            : item.data.data.updated_admin
          }
        }
      } catch (error){
        alert(error)
      } finally {
        this.$store.dispatch("app/stopPageLoading");
      }
    },
  },
  mounted(){
    this.$_fetchData()
  }
};
</script>